<template>
  <v-container fluid class="itemgroup-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
          centered
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-account-outline</v-icon>
            Item Group
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Item Group</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemgroupcode')"
                        v-bind:value="initvalue.itemgroupcode"
                        placeholder="ItemGroup Code"
                        persistent-hint
                        single-line hint="Enter the itemgroup code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemgroupname')"
                        v-bind:value="initvalue.itemgroupname"
                        placeholder="ItemGroup Name"
                        persistent-hint
                        single-line hint="Enter the itemgroup name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.itemgrouptype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemgrouptype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the itemgroup type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'itemgroupstatus')"
                          v-bind:label="initvalue.itemgroupstatus"
                          v-model="initvalue.itemgroupstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/itemgroup/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editItemGroup()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/itemgroup/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      itemgroup: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      imageurl: undefined,
      items: ['Item Group', 'Other Item Group'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('ItemGroup', [
      'updateItemGroupRequest',
      'updateItemGroupImageRequest',
      'updateItemGroupPinRequest',
      'getItemGroupsRequest'
    ]),
    editItemGroup() {
      this.itemgroup._id = this.initvalue._id;
      this.updateItemGroupRequest(this.itemgroup);
      this.getItemGroupsRequest();
      router.push('/itemgroup/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateItemGroupRequest(this.detail);
      this.getItemGroupsRequest();
      router.push('/itemgroup/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateItemGroupImageRequest(this.photo);
      this.getItemGroupsRequest();
      router.push('/itemgroup/list');
    },
    editPin() {
      console.log(this.pin);
      if(this.pin.itemgrouppin == undefined || this.pin.itemgrouppin.length<6){
        this.pin.error = true;
        return;
      }
      this.pin.error = false;
      if(this.pin.itemgrouppin !== this.pin.itemgrouppin2){
        this.pin.error2 = true;
        return;
      }
      this.pin.error2 = false;
      this.pin._id = this.initvalue._id;
      console.log(this.pin);
      this.updateItemGroupRequest(this.pin);
      this.getItemGroupsRequest();
      router.push('/itemgroup/list');
    },
    updateChangedValue(value, field){
      console.log(value, field);
      this.itemgroup[field] = value;
    },
    updateChangedDetail(value, field){
      console.log(value, field);
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.itemgroupimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('ItemGroup', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    console.log(this.initvalue)
    this.imageurl = this.initvalue.itemgroupimage;
    console.log(this.initvalue);
    if(!this.initvalue._id) this.$router.push({ name: 'ItemGroupList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
